'use client';

import { Modal } from '@/components/ui/Modal';
import { LoginFormCard } from './LoginFormCard';

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenRegister?: () => void;
}

export const LoginModal: React.FC<LoginModalProps> = ({ isOpen, onClose, onOpenRegister }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <LoginFormCard onLoginSuccess={() => onClose()} onClose={onClose} onOpenRegister={onOpenRegister} />
    </Modal>
  );
};

export default LoginModal;
